import { CRMAPIBase } from "@api/crmApiBase";
import { ScheduleExceptionStatusListResp } from "@api/responseModels/worker/schedule/scheduleExceptionStatusListResponse";
import { ScheduleExceptionStatusResp } from "@api/responseModels/worker/schedule/scheduleExceptionStatusResponse";
import { TScheduleExceptionStatus } from "@components/schedule/common/types";

class ScheduleExceptionStatusGroup extends CRMAPIBase {
    async saveScheduleExceptionStatus(
        es: TScheduleExceptionStatus 
    ) {
        const result = await this.post<ScheduleExceptionStatusResp>('/schedule-exception-statuses', {
            ...es
        });
        return result;
    }

    async getScheduleExceptionStatus(
        crm_id: number,
        id: number
    ) {
        const result = await this.get<ScheduleExceptionStatusResp>(`/schedule-exception-statuses/${id}`, {
            crm_id
        });
        return result;
    }

    async getScheduleExceptionStatusList() {
        const result = await this.get<ScheduleExceptionStatusListResp>('/schedule-exception-statuses');
        return result;
    }

    async updateScheduleExceptionStatus(
        es: TScheduleExceptionStatus
    ) {
        const result = await this.put<ScheduleExceptionStatusResp>(`/schedule-exception-statuses/${es.id}`, {
            ...es
        });
        return result;
    }

    async removeScheduleExceptionStatus(crm_id: number, id: number) {
        const result = await this.delete<ScheduleExceptionStatusResp>(`/schedule-exception-statuses/${id}`, {
            crm_id
        });
        return result;
    }

    async restoreScheduleExceptionStatus(crm_id: number, id: number) {
        const result = await this.post<ScheduleExceptionStatusResp>(`/schedule-exception-statuses/${id}/restore`, {
            crm_id
        });
        return result;
    }
}

export { ScheduleExceptionStatusGroup };